module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-KELAS-PINTAR-MINGGUAN-2.8944585d.png";